var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Icon from '@ant-design/icons';
var ArrowDownBoldSVG = function () { return (React.createElement("svg", { width: '10', height: '6', viewBox: '0 0 10 6', fill: 'currentColor', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement("path", { d: 'M8.94662 0.453125H4.79329H1.05329C0.413288 0.453125 0.0932878 1.22646 0.546621 1.67979L3.99995 5.13312C4.55329 5.68646 5.45329 5.68646 6.00662 5.13312L7.31995 3.81979L9.45995 1.67979C9.90662 1.22646 9.58662 0.453125 8.94662 0.453125Z', fill: 'currentColor' }))); };
export var ArrowDownBold = function (props) { return (React.createElement(Icon, __assign({ component: ArrowDownBoldSVG }, props))); };
//# sourceMappingURL=ArrowDownBold.js.map